module.exports = __webpack_public_path__ + "static/media/kerava-logo.8dbc9284.jpg";